// test1272
(1272 && 0);
